import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dropzone-background" }
const _hoisted_2 = { class: "overlay" }

import { Background } from '@vue-flow/background'

export default /*@__PURE__*/_defineComponent({
  __name: 'DropzoneBackground',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Background), {
      size: 1,
      gap: 20,
      "pattern-color": "#cbd7e6"
    }),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})